<template>
    <span v-if="props.status" class="badges badges-bg badges-active ">
        {{ i18n.t('status.active' ) }}
    </span>
    <span v-else class="badges badges-bg badges-expired"  >
        {{ i18n.t('status.expired'  ) }}
    </span>
</template>
<script setup>
import { defineProps } from 'vue';
import i18n from '@/i18n/index'
const props = defineProps({
    status: {
        type: [String],
        default: null,
    },
});
</script>